export default {
  TEXT: 'Text',
  QUIZ: 'Quiz',
  PAIRS: 'Pairs',
}
